import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Select,
  Text,
  Spinner,
  Box,
  VStack,
} from '@chakra-ui/react';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

const CompleteSprintModal = ({
  isOpen,
  onClose,
  projectId,
  getTaskBoardDetails,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedActiveSprint, setSelectedActiveSprint] = useState('');
  const [selectedFutureSprint, setSelectedFutureSprint] = useState('');

  // Simulated API call (replace with your actual endpoint)
  const [activeSprints, setActiveSprints] = useState([]);
  const [futureSprints, setFutureSprints] = useState([]);
  const [taskSummary, setTaskSummary] = useState({
    completed: 0,
    open: 0,
  });

  const getsprintlist = async () => {
    try {
      const response = await httpInjectorService.getsprintList(projectId);
      if (response.status === 'success') {
        setActiveSprints(response.data?.active_sprints || []);
        setFutureSprints(response.data?.future_sprints || []);
      } else {
        setActiveSprints([]);
        setFutureSprints([]);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (isOpen) {
      getsprintlist();
    }
  }, [isOpen]);

  const handleCompleteSprint = async () => {
    try {
      const reqBody = {
        project_id: projectId,
        sprint_id: Number(selectedActiveSprint),
        target_sprint_id: selectedFutureSprint
          ? Number(selectedFutureSprint)
          : null,
      };

      const response = await httpInjectorService.completeSprint(reqBody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        getTaskBoardDetails();
        onClose();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const getsprinttasksummary = async (sprintId) => {
    const queryParams = `?sprint_id=${sprintId}&project_id=${projectId}`;
    try {
      setLoading(true);
      const response =
        await httpInjectorService.getSprintTaskSummary(queryParams);
      if (response.status === 'success') {
        setTaskSummary({
          completed: Number(response.data.completed_items) || 0,
          open: Number(response.data.open_items) || 0,
        });
      }
    } catch (error) {
      console.error('Error fetching sprint task summary:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleActiveSprintChange = (e) => {
    const sprintId = e.target.value;
    setSelectedActiveSprint(sprintId);
    if (sprintId) {
      getsprinttasksummary(sprintId);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Complete sprint</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <Box textAlign="center" py={6}>
              <Spinner />
            </Box>
          ) : (
            <VStack align="stretch" spacing={4}>
              {/* Select Active Sprint */}
              <Box>
                <Text fontWeight="medium">Select a sprint</Text>
                <Select
                  placeholder="Select sprint"
                  value={selectedActiveSprint}
                  onChange={handleActiveSprintChange}
                >
                  {activeSprints.map((sprint) => (
                    <option key={sprint.sprint_id} value={sprint.sprint_id}>
                      {sprint.sprint_name}
                    </option>
                  ))}
                </Select>
              </Box>

              {/* Sprint details */}
              {selectedActiveSprint && (
                <Box fontSize="sm" color="gray.600">
                  This sprint contains{' '}
                  <b>{taskSummary.completed} completed work item(s)</b> and{' '}
                  <b>{taskSummary.open} open work item(s)</b>.
                  <ul style={{ marginLeft: '20px', marginTop: '5px' }}>
                    <li>
                      Completed work items includes everything in the last
                      column on the board,{' '}
                      <span style={{ color: '#0052CC' }}>Done</span>.
                    </li>
                    <li>
                      Open work items includes everything from any other column
                      on the board. Move these to a new sprint or the backlog.
                    </li>
                  </ul>
                </Box>
              )}

              {/* Select Future Sprint */}
              <Box>
                <Text fontWeight="medium">Move open work items to</Text>
                <Select
                  placeholder="Select future sprint"
                  value={selectedFutureSprint}
                  onChange={(e) =>
                    setSelectedFutureSprint(e.target.value || null)
                  } // Set null for backlog
                >
                  {/* Backlog Option */}
                  <option value={0}>Backlog</option>

                  {futureSprints.map((sprint) => (
                    <option key={sprint.sprint_id} value={sprint.sprint_id}>
                      {sprint.sprint_name}
                    </option>
                  ))}
                </Select>
              </Box>

              {/* Checkbox */}
              {/* <Checkbox
                isChecked={retrospective}
                onChange={(e) => setRetrospective(e.target.checked)}
              >
                Create a retrospective for this sprint
              </Checkbox>
              <Text fontSize="sm" color="gray.600" ml={6}>
                Finish off your sprint with a Confluence retrospective! Contribute to your team's culture and improve how you work.
              </Text> */}
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            bg="#722ED1"
            color="white"
            size="sm"
            _hover={{ bg: '#5a1fb3' }}
            onClick={handleCompleteSprint}
          >
            Complete sprint
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CompleteSprintModal;
